import { useEffect } from "react";

export const DocumentTitle = props => {
    const { title } = props;
    useEffect(() => {
        document.title = title || "";
    });
    return null;
};
